<script>
import {required} from "vuelidate/lib/validators";
import appConfig from "@/app.config";
import {notifyModel} from "@/models/notifyModel";
import {pagingModel} from "@/models/pagingModel";
import {linhVucModel} from "@/models/linhVucModel";
import {CONSTANTS} from "@/helpers/constants";
import {hopThuModel} from "@/models/hopThuModel";
import Multiselect from "vue-multiselect";
import LayoutMail from "@/router/layouts/LayoutMail";
import ListFile from "@/pages/hopThu/listFile";
import DatePicker from "vue2-datepicker";
import Detail from "@/pages/hopThu/detail";
import moment from "moment";
import _ from "lodash";

export default {
  page: {
    title: "Thư đến",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Detail, LayoutMail, ListFile, Multiselect, DatePicker},
  data() {
    return {
      optionsUser: [],
      data: [],
      showModal: false,
      showDetail: false,
      showDeleteModal: false,
      submitted: false,
      model: hopThuModel.baseJson(),
      pagination: pagingModel.baseJson(),
      totalRows: 1,
      currentPage: 1,
      numberOfElement: 1,
      perPage: 20,
      pageOptions: [20, 50, 80, 100],
      filter: null,
      filterOn: [],
      isBusy: false,
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: 'STT',
          label: 'STT',
          sortable: false,
          class: "text-center text-thuden",
          thClass: 'hidden-sortable text-center',
          thStyle: {width: '50px', minWidth: '50px'},
        },
        {
          key: "tieuDe",
          label: "Tiêu đề",
          class: 'text-thuden',
          sortable: true,
          thStyle: "text-align:left",
          thClass: 'hidden-sortable',
        },
        {
          key: "files",
          label: "",
          class: 'text-thuden text-center cs-show-col',
          thStyle: {width: '50px', minWidth: '50px'},
          sortable: true,
          thClass: 'hidden-sortable text-center',
        },
        {
          key: "nguoiGui",
          label: "Người gửi",
          class: 'text-thuden text-center cs-show-col',
          thStyle: {width: '200px', minWidth: '100px'},
          sortable: true,
          thClass: 'hidden-sortable text-center',
        },
        {
          key: "ngayNhan",
          label: "Ngày nhận",
          class: 'text-thuden text-center cs-show-col',
          sortable: true,
          thStyle: {width: '100px', minWidth: '100px'},
          thClass: 'hidden-sortable text-center',
        },
        {
          key: 'process',
          label: '',
          class: 'text-thuden',
          thStyle: {width: '50px', minWidth: '50px'},
          thClass: 'hidden-sortable',
          sortable: false
        }
      ],
      apiUrl: process.env.VUE_APP_API_URL,
      url: `${process.env.VUE_APP_API_URL}files/upload`,
      urlView: `${process.env.VUE_APP_API_URL}files/view/`,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}files/upload`,
        thumbnailWidth: 300,
        thumbnailHeight: 160,
        maxFiles: 4,
        maxFilesize: 30,
        headers: {"My-Awesome-Header": "header value"},
        addRemoveLinks: true,
        acceptedFiles: ".doc,.docx,.pdf",
        dropzoneClassName: "dropzonevue-box"
      },
      editorConfig: {
        height: '200px',
        toolbar: {
          items: [
            'heading',
            'bold',
            'italic',
            'bulletedList',
            'numberedList',
            'undo',
            'redo',
          ]
        },
      },
      optionsUserTree: [],
      valueConsistsOf: 'LEAF_PRIORITY',
      showChiTietModal: false,
      showChuyenTiepModal: false,
      itemFilter: {
        title: null,
        nguoiTao: null,
        ngayTao: null,
      },
      showListFile: false,
      listFiles: [],
      trangThaiXem:[
        {
          id: "DAXEM",
          name: "Đã xem"
        },
        {
          id: "CHUAXEM",
          name: "Chưa xem"
        },
      ],
      showDetailMail: false,
      detailMailId: null,
      date: null
    };
  },
  validations: {
    model: {
      tieuDe: {required},
      nguoiNhans: {required},
    },
  },
  created() {
    this.getUserTree();
    this.getUser();
  },
  watch: {
    model: {
      deep: true,
      handler(val) {
      }
    },
    itemFilter: {
      deep: true,
      handler(val) {
        this.$refs.tblList?.refresh()
      }
    },
  },
  methods: {
    debounceInput: _.debounce(function (e) {
      if(this.itemFilter){
        this.itemFilter.title = e.target.value;
      }
    }, 500),
    formatDateDownload(formatDate){
      let dateTemp = moment(formatDate, "DD-MM-YYYY HH:mm:ss");
      return dateTemp.format("DD_MM_YYYY_HH_mm_ss");
    },
    backListMail(){
      this.showDetailMail = false;
    },
    async fnGetList() {
      this.$refs.tblList?.refresh()
    },
    async handleUpdate(id) {
      await this.$store.dispatch("dmLinhVucStore/getById", id).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.model = linhVucModel.fromJson(res.data);
          this.showModal = true;
        } else {
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
          this.$refs.tblList.refresh()
        }
      });
    },
    async handleDetail(id) {
      await this.$store.dispatch("dmLinhVucStore/getById", id).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.model = linhVucModel.fromJson(res.data);
          this.showDetail = true;
        } else {
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        }
      });
    },
    async handleDelete() {
      if (this.model.userMailId != 0 && this.model.userMailId != null && this.model.userMailId) {
        await this.$store.dispatch("mailStore/deleteMail", this.model.userMailId).then((res) => {
          if (res.resultCode === 'SUCCESS') {
            this.showDeleteModal = false;
            this.$refs.tblList.refresh()
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        });
      }
    },
    handleShowDeleteModal(id) {
      this.model.userMailId = id;
      this.showDeleteModal = true;
    },
    async handleSubmit(e, text) {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        if (
            this.model.id != 0 &&
            this.model.id != null &&
            this.model.id
        ) {
          // Update model
          await this.$store.dispatch("hopThuStore/createSend", this.model).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.showModal = false;
              this.showChuyenTiepModal = false;
              this.$refs.tblList.refresh()
              this.$store.dispatch("snackBarStore/addNotify", {resultCode: "SUCCESS", resultString: text})
            } else {
              this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
            }

          });
        } else {
          // Create model
          await this.$store.dispatch("hopThuStore/createSend", this.model).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.showModal = false;
              this.showChuyenTiepModal = false;
              this.$refs.tblList.refresh()
              this.model = hopThuModel.baseJson();
              this.$store.dispatch("snackBarStore/addNotify", {resultCode: "SUCCESS", resultString: text})
            } else {
              this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
            }

          });
        }
        loader.hide();
      }
      this.submitted = false;
    },
    myProvider(ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        content: this.itemFilter.title,
        nguoiTao: this.itemFilter.nguoiTao,
        ngayTao: this.itemFilter.ngayTao,
        trangThaiXem: this.itemFilter.trangThaiXem,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
      }
      this.loading = true
      try {
        let promise = this.$store.dispatch("mailStore/getPagingParams", params)
        return promise.then(resp => {
          if (resp.resultCode == CONSTANTS.SUCCESS) {
            let data = resp.data;
            this.totalRows = data.totalRows
            let items = data.data
            this.numberOfElement = items.length
            this.loading = false
            return items || []
          } else {
            return [];
          }
        })
      } finally {
        this.loading = false
      }
    },
    async getUser() {
      try {
        await this.$store.dispatch("userStore/getAll").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsUser = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    async getUserTree() {
      try {
        await this.$store.dispatch("userStore/userTreeForDonVi").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsUserTree = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    normalizer(node) {
      if (node.children == null || node.children == 'null') {
        delete node.children;
      }
    },
    removeThisFile(file, error, xhr) {
      let fileCongViec = JSON.parse(file.xhr.response);
      if (fileCongViec.data && fileCongViec.data.id) {
        let idFile = fileCongViec.data.id;
        let resultData = this.model.uploadFiles.filter(x => {
          return x.fileId != idFile;
        })
        this.model.uploadFiles = resultData;
      }
    },
    addThisFile(file, response) {
      if (this.model) {
        if (this.model.uploadFiles == null || this.model.uploadFiles.length <= 0) {
          this.model.uploadFiles = [];
        }
        let fileSuccess = response.data;
        this.model.uploadFiles.push({fileId: fileSuccess.id, fileName: fileSuccess.fileName, ext: fileSuccess.ext, size: fileSuccess.size})
      }
    },
    handleShowChiTietModal(id) {
      // this.$router.push('hop-thu/chi-tiet/' + id)
      this.showDetailMail = true;
      this.detailMailId = id;
    },
    handleCreate() {
      this.model = hopThuModel.baseJson();
      this.showModal = true;
    },
    handleTraLoi(tatca) {
      this.model.tieuDe = "Re: " + this.model.tieuDe;
      this.model.noiDung = null;
      if (tatca) {
        this.model.cc = null;
      }
      this.showChiTietModal = false;
      this.showModal = true;
    },
    handleChuyenTiep() {
      this.model.cc = null
      this.model.nguoiNhans = null;
      this.showChiTietModal = false;
      this.showChuyenTiepModal = true;
    },
    handleShowListFile(files, date){
      this.showListFile = true;
      this.listFiles = files;
      this.date = date;
    },
    rowClass(item) {
      if (item.read === false) return "cs-table-read"
    },
  }
}
</script>
<template>
  <LayoutMail>
    <div v-if="!showDetailMail">
      <div class="row">
        <div class="col-12">
          <div class="card" style="margin-bottom: 10px;">
            <div class="card-body">
              <div class="row align-items-end">
                <div class="col-lg-12 col-md-12  col-12">
                  <div class="row ">
                    <div class="col-lg-3 col-md-6 col-12">
                      <label>Nội dung</label>
                      <input size="sm" type="text" name="untyped-input" class="form-control" :value="itemFilter.title"
                             v-on:input="debounceInput"
                             placeholder="Tiêu đề"/>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12">
                      <label>Người gửi</label>
                      <multiselect v-model="itemFilter.nguoiTao" :options="optionsUser" track-by="id" label="fullName"
                                   placeholder="Chọn người gửi" deselect-label="Nhấn để xoá"
                                   selectLabel="Nhấn enter để chọn"
                                   selectedLabel="Đã chọn">

                        <template slot="singleLabel" slot-scope="{ option }">
                          <strong>{{ option.fullName }}</strong>

                          <span v-if="option.donVi" style="color:red">&nbsp;{{ option.donVi.ten }}</span>
                        </template>
                        <template slot="option" slot-scope="{ option }">
                          <div class="option__desc">
          <span class="option__title">
            <strong>{{ option.fullName }}&nbsp;</strong>
          </span>
                            <span v-if="option.donVi" class="option__small"
                                  style="color:green">{{ option.donVi.ten }}</span>
                          </div>
                        </template>

                      </multiselect>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12">
                      <label>Ngày nhận</label>
                      <date-picker v-model="itemFilter.ngayTao"
                                   format="DD/MM/YYYY"
                                   value-type="format"
                      >
                        <div slot="input">
                          <input v-model="itemFilter.ngayTao"
                                 v-mask="'##/##/####'" type="text" class="form-control"
                                 placeholder="Nhập ngày tạo"/>
                        </div>
                      </date-picker>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12">
                      <label>Trạng thái xem</label>
                      <multiselect v-model="itemFilter.trangThaiXem" :options="trangThaiXem" track-by="id" label="name"
                                   placeholder="Chọn trạng thái xem" deselect-label=""
                                   selectLabel=""
                                   selectedLabel=""></multiselect>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
              </div>
              <!--            Pagination -->
              <div class="row">
                <div class="col-12">
                  <div class="table-responsive-sm">
                    <b-table
                        class="datatables"
                        :items="myProvider"
                        :fields="fields"
                        bordered
                        responsive="sm"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        ref="tblList"
                        primary-key="id"
                        :busy.sync="isBusy"
                        :tbody-tr-class="rowClass"
                    >
                      <template v-slot:cell(STT)="data">
                        {{ data.index + ((currentPage - 1) * perPage) + 1 }}
                      </template>
                      <template v-slot:cell(process)="data">
                        <div class="d-flex justify-content-center">
                          <button
                              type="button"
                              size="sm"
                              class="btn btn-delete btn-sm"
                              data-toggle="tooltip" data-placement="bottom" title="Xóa"
                              v-on:click="handleShowDeleteModal(data.item.userMailId)">
                            <i class="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </template>
                      <template v-slot:cell(tieuDe)="data">
                        <div @click="handleShowChiTietModal(data.item.userMailId)"
                             style="cursor: pointer">
                          <strong v-if="!data.item.read">{{data.item.title}}</strong>
                          <div v-else> {{ data.item.title }}</div>
                        </div>

                      </template>
                      <template v-slot:cell(ngayNhan)="data">
                        {{ data.item.dateSend }}
                      </template>
                      <template v-slot:cell(files)="data">
                        <div v-if="data.item.files && data.item.files.length > 0">
                          <a href="javascript:void(0)" @click="handleShowListFile(data.item.files, data.item.dateSendFull)">
                            <i class="fas fa-cloud-download-alt"></i>
                          </a>
                        </div>
                      </template>

                      <template v-slot:cell(nguoiGui)="data">
                        <div v-if="data.item.sender">
                          {{ data.item.sender }}
                        </div>

                      </template>
                    </b-table>
                    <template v-if="isBusy">
                      <div align="center">Đang tải dữ liệu</div>
                    </template>
                    <template v-if="totalRows <= 0 && !isBusy">
                      <div align="center">Không có dữ liệu</div>
                    </template>
                  </div>
                  <!-- Paginnation -->
                  <div>
                    <div class="row mb-2">
                      <div class="col-sm-12 col-md-6">
                        <div style="display: flex; justify-content: start; align-items: center">
                          <div style="margin-right: 20px" class="">
                            <div id="tickets-table_length" class="dataTables_length">
                              <label class="d-inline-flex align-items-center">
                                Hiện
                                <b-form-select
                                    class="form-select form-select-sm"
                                    v-model="perPage"
                                    size="sm"
                                    :options="pageOptions"
                                ></b-form-select
                                >&nbsp;dòng
                              </label>
                            </div>

                          </div>
                          <div class="">
                            <div>Hiển thị {{ numberOfElement }} trên tổng số {{ totalRows }} dòng</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-6">
                        <div
                            class="dataTables_paginate paging_simple_numbers float-end">
                          <ul class="pagination pagination-rounded mb-0">
                            <!-- pagination -->
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalRows"
                                :per-page="perPage"
                            ></b-pagination>
                          </ul>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>
          <!--        Modal delete -->
          <b-modal
              v-model="showDeleteModal"
              centered
              title="Xóa dữ liệu thư"
              title-class="fw-bold fs-5 text-dark"
              no-close-on-backdrop
          >
            <p>
              Dữ liệu xóa sẽ không được phục hồi!
            </p>
            <template #modal-footer>
              <b-button v-b-modal.modal-close_visit
                        size="sm"
                        class="btn btn-outline-info w-md"
                        v-on:click="showDeleteModal = false">
                Đóng
              </b-button>
              <b-button v-b-modal.modal-close_visit
                        size="sm"
                        variant="danger"
                        type="button"
                        class="w-md"
                        v-on:click="handleDelete">
                Xóa
              </b-button>
            </template>
          </b-modal>

          <b-modal
              v-model="showChiTietModal"
              centered
              title="Thông tin"
              title-class="fw-bold fs-5 text-dark"
              no-close-on-backdrop
              size="lg"
              hide-footer
          >
            <div class="title-hopthu-main" style="text-align: justify">
              {{ model.tieuDe }}
            </div>
            <div class="cs-border-tabs">
              <b-tabs pills class="navtab-bg border-0" content-class="p-3">
                <b-tab active>
                  <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="mdi mdi-file-document"></i>
                  </span>
                    <span class="d-none d-sm-inline-block">Nội dung</span>
                  </template>
                  <div class="content-tabs">
                    <div v-if="model.noiDung" class="mt-2">
                      <div :inner-html.prop="model.noiDung" style="text-align: justify">
                      </div>
                    </div>
                    <div class="col-md-12">
                      <template v-if="model.files == null || (model.files != null &&model.files.length <= 0)">
                      </template>
                      <template v-else>
                        <div v-for="(value, index) in model.files" :key="index"
                             style="background-color: rgba(47,147,224,0.1); border-radius: 3px; padding: 5px; margin-bottom: 5px">
                          <a :href="`${apiUrl}files/view/${value.fileId}`" class="fw-medium"
                          ><i class="fas fa-cloud-download-alt"></i> [Tải về]</a
                          >
                          <a
                              target="_blank"
                              class="fw-medium text-danger"
                              @click="handleShowFile(value.fileId)"
                              style="cursor: pointer"
                          >
                            [Xem]</a
                          >
                          <span
                              style="padding-left: 20px; font-weight: 500; color: #2f93e0"
                          >{{ value.fileName }}</span
                          >
                        </div>
                      </template>
                    </div>
                  </div>
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="mdi mdi-card-account-details-outline"></i>
                  </span>
                    <span class="d-none d-sm-inline-block">Thông tin người gửi</span>
                  </template>
                  <div class="content-tabs">
                    <div class="col-md-6 col-m-12">
                      <div style="margin-bottom: 5px">
                        <div v-if="model.ngayNhanFull" style="margin-right: 10px; font-size: 14px"
                             class="d-flex flex-column text-success">
                          <label class="text-black-50"> NGÀY GỬI: </label>
                          <span>{{ model.ngayNhanFull }}</span>

                        </div>
                        <div v-if="model.nguoiGui" style="margin-right: 10px; font-size: 14px"
                             class="d-flex flex-column text-success">
                          <label class="text-black-50"> NGƯỜI TẠO: </label>
                          {{ model.nguoiGui.fullName }}
                          <template v-if="model.nguoiGui.donVi">
                            -{{ model.nguoiGui.donVi.ten }}
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
            <template #modal-header="{  }">
              <!-- Emulate built in modal header close button action -->
              <h5 class="fw-bold fs-5 text-dark">Thông tin chi tiết</h5>
              <div class="text-end">
                <b-button variant="info" class="w-md me-1" size="sm" @click="handleChuyenTiep">
                  Chuyển tiếp
                </b-button>
                <b-button variant="primary" class="w-md me-1" size="sm" @click="handleTraLoi(true)">
                  Trả lời
                </b-button>
                <b-button variant="success" class="w-md me-1" size="sm" @click="handleTraLoi()">
                  Trả lời tất cả
                </b-button>
                <b-button variant="light" class="w-md me-1" size="sm" @click="showChiTietModal = false">
                  Đóng
                </b-button>
              </div>
            </template>
          </b-modal>
        </div>
      </div>
    </div>
    <div v-else>
      <Detail :back-list-mail="backListMail" :mail-id="detailMailId"></Detail>
    </div>

    <!--    List files-->
    <ListFile :date="formatDateDownload(date)" :show-modal.sync="showListFile" :files.sync="listFiles"></ListFile>
  </LayoutMail>
</template>
<style>
.td-stt {
  text-align: center;
  width: 30px;
}

.td-xuly {
  text-align: center;
  width: 100px;
}

.hidden-sortable:after, .hidden-sortable:before {
  display: none !important;
}

.title-capso {
  font-weight: 500;
  color: #00568C;
  margin-right: 10px;

}

.title-hopthu {
  font-weight: bold;
  color: #00568C;
  margin-right: 5px;
}

.text-thuden {
  padding: 0px
}

.title-hopthu-main {
  font-weight: bold;
  color: #00568C;
  margin-right: 10px;
  font-size: 16px;
  margin-bottom: 10px;
}

th.text-thuden {
  color: #00568C;
  font-weight: bold;
}

td.text-thuden {
  padding-left: 10px;
}

@media only screen and (max-width: 768px) {
  /*
  Label the data
  */
  .table-thuden > td:nth-of-type(1):before {
    content: "STT";
    font-weight: bold;
    color: #00568c;
  }

  .table-thuden > td:nth-of-type(2):before {
    content: "Tiêu đề";
    font-weight: bold;
    color: #00568c;
  }

  .table-thuden > td:nth-of-type(3):before {
    content: "";
    font-weight: bold;
    color: #00568c;
  }

  .table-thuden > td:nth-of-type(4):before {
    content: "Người gửi";
    font-weight: bold;
    color: #00568c;
  }

  .table-thuden > td:nth-of-type(5):before {
    content: "Ngày nhận";
    font-weight: bold;
    color: #00568c;
  }

  .table-thuden > td:nth-of-type(6):before {
    content: "";
    font-weight: bold;
    color: #00568c;
  }
}

.dropzonevue-box {
  position: relative;
}

.dropzone-custom-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

</style>

<style lang="scss">
.cs-border-tabs {
  background: #ddd;
  border: 0.5px solid #ccc;
  padding: 3px;

  & .nav-link {
    border-radius: 0px;
  }

  & .tab-content {
    background: #fff;
    margin-top: 3px;
    border: 0.5px solid #ccc;
  }
}

.cs-treeselect {
  & .vue-treeselect__control {
    border: none;
    border-bottom: 0.5px solid #d0d0d0;
    border-radius: 0px;
  }
}

.cs-input-border {
  border: none;
  border-bottom: 0.5px solid #d0d0d0;
  border-radius: 0px;
}

.cs-ckeditor {
  & .ck {
    &.ck-editor{
      display: flex;
      flex-direction: column-reverse;
    }
    &.ck-toolbar {
      background-color: #fff !important;
    }
    & .ck-editor__main{
      & .ck-content{
        border: none;
      }
    }
  }
}

.cs-modal-hopthu{
  & .modal-header{
      background-color: #f2f6fc;
      border: none !important;
  }
}
</style>
